import { render, staticRenderFns } from "./ClockTop.vue?vue&type=template&id=47b8a0ac&scoped=true"
import script from "./ClockTop.vue?vue&type=script&lang=js"
export * from "./ClockTop.vue?vue&type=script&lang=js"
import style0 from "./ClockTop.vue?vue&type=style&index=0&id=47b8a0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b8a0ac",
  null
  
)

export default component.exports